import { useMutation, useQuery } from "@tanstack/react-query";
import { createProjectGeofence, deleteProjectGeofence, getProjectGeofence, updateProjectGeofence } from "../api/geofence.service";
export const useGetProjectGeofenceDetailsQuery = (projectId, partyNumber) => {
    return useQuery({
        enabled: false,
        gcTime: 0,
        queryFn: async () => {
            return await getProjectGeofence(projectId, partyNumber);
        },
        queryKey: [projectId, partyNumber],
        retry: false
    });
};
export const useCreateProjectGeofenceMutate = (projectId, partyNumber) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (projectGeofenceCreateRequest) => {
            return createProjectGeofence(projectId, partyNumber, projectGeofenceCreateRequest);
        },
        retry: false
    });
};
export const useDeleteProjectGeofenceMutate = (projectId, partyNumber) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (geofenceId) => {
            return deleteProjectGeofence(projectId, geofenceId, partyNumber);
        },
        retry: false
    });
};
export const useUpdateProjectGeofenceMutate = (projectId, partyNumber) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (updateProjectGeofenceRequest) => {
            return updateProjectGeofence(projectId, updateProjectGeofenceRequest.geofenceId, partyNumber, updateProjectGeofenceRequest.requestBody);
        },
        retry: false
    });
};
